import { useState } from 'react';

function useCancelConnectPlanDialogState ({ onConfirm }) {
    const [checked, setChecked] = useState(false);
    const [step, setStep] = useState('confirm');
    const [error, setError] = useState('');

    async function handleConfirm () {
        if (!checked || step === 'processing') {
            return;
        }
        setError('');
        setStep('processing');
        try {
            const result = await onConfirm();
            if (result && result.error) {
                const message = result.error.message || 'Failed to cancel Connect plan.';
                setError(message.charAt(0).toUpperCase() + message.slice(1));
                setStep('confirm');
                return;
            }
            setStep('done');
        } catch {
            setError('Failed to cancel Connect plan. Please try again.');
            setStep('confirm');
        }
    }

    return {
        checked,
        setChecked,
        step,
        error,
        handleConfirm,
    };
}

export default useCancelConnectPlanDialogState;
